import { catchError, EMPTY, from, Observable, switchMap, take, tap, TimeoutError } from 'rxjs';
import { inject } from '@angular/core';
import { MODAL_TOKEN, ModalProvider, TOAST_TOKEN, ToastProvider, USER_DATA_TOKEN, UserDataProvider } from '@core';
import { AuthService } from '@auth/infra';

export class AuthWithProviderCommandHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly toastProvider: ToastProvider = inject(TOAST_TOKEN);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  authWithGoogle(): Observable<void> {
    return this.modalProvider.showLoading$().pipe(
      switchMap(() => from(this.authService.authWithGoogle())),
      tap(() => this.userDataProvider.setUserData()),
      catchError((err: unknown) => this.handleProviderError(err)),
      take(1)
    );
  }

  authWithApple(): Observable<void> {
    return this.modalProvider.showLoading$().pipe(
      switchMap(() => from(this.authService.authWithApple())),
      tap(() => this.userDataProvider.setUserData()),
      catchError((err: unknown) => this.handleProviderError(err)),
      take(1)
    );
  }

  authWithFacebook(): Observable<void> {
    return this.modalProvider.showLoading$().pipe(
      switchMap(() => from(this.authService.authWithFacebook())),
      tap(() => this.userDataProvider.setUserData()),
      catchError((err: unknown) => this.handleProviderError(err)),
      take(1)
    );
  }

  private handleProviderError(err: unknown): Observable<never> {
    this.modalProvider.dismissLoading();

    if (err instanceof TimeoutError) {
      this.toastProvider
        .showToast$({
          message: 'Ta metoda logowania jest niedostępna na Twoim urządzeniu. Spróbuj inną.',
          duration: 5000
        })
        .subscribe();
    }

    return EMPTY;
  }
}
